import { relativeRoutes, routes } from './routes';

export const isHome = (pathname: string) => pathname === routes.base;

export const isLocalRoute = (pathname: string) =>
  isHome(pathname) ||
  Object.values(routes).some(route => !isHome(route) && pathname.startsWith(route));

export const isSectionRoute = (pathname: string) => pathname.startsWith(`${routes.menu}/section-`);

export const isRecentItemsRoute = (pathname: string) =>
  pathname.startsWith(`${routes.menu}/${relativeRoutes.recentItems}`);

export const isFavoritesRoute = (pathname: string) => pathname.startsWith(routes.favorites);

export const isItemPickerOrComboRoute = (pathname: string) =>
  new RegExp(`^${routes.menu}/(item|picker|combo)-`).test(pathname);
